module.exports = __webpack_public_path__ + "static/img/brees-homepage-hero-bit.0b5107c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-homepage-hero-bit.gif
// module id = ESjG
// module chunks = 1